define('models/reactor', [], function() {
    return WCC.Reactor;
});